import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import './sideNavBarCss.css'
import PropTypes from 'prop-types';

class Sidebar extends Component{
    constructor(props){
        super(props)
        this.state = {}
    }
    _onClickHandler(e){
        this.setState( (prevState) =>{
            return {
                ...prevState,
                [e.target.id]: (this.state[e.target.name] ? false : true)
            }
        })
    }
    UNSAFE_componentWillMount(){
        let storedTk = localStorage.getItem('tk');
        let uma = [];
        let role = '';
        if(storedTk){
            storedTk = JSON.parse(this.base64decode((storedTk)));
            if(Object.keys(storedTk).includes('uma')){
                 uma = this.base64decode(storedTk['uma']);
                 role = this.base64decode(storedTk['ur']);
            }
        }
        uma = uma.length ? uma.split(',') : uma;
        this.setState({
            'userManagementAccess': uma,
            'userRole': role
        })
    }
    base64decode(arg){
        return window.atob(arg);
    }
    render() {
        // let userManagementControls = (
        //     <ul className="nav flex-column">
        //        <li className="nav-item has-submenu">
	    //        	<a className="nav-link collapsed" href="#" data-toggle="collapse" id="userMenuATag"
	    //        	href="#userMenu" role="button" aria-expanded="false">
	    //        	    <i className="fa fa-users cus-margin-rt-5"></i>
	    //        	    Users
	    //        	    <i className="fa fa-angle-down arrow cus-float-right"></i>
	    //        	</a>
	    //        	<div className="collapse" id="userMenu">
	    //        	    <ul className="submenu">
	    //        	    	<li>
	    //        	    	    <Link to="/register" className="nav-link" >
        //                           <i className="fa fa-user-plus cus-margin-rt-5"></i>
	    //        	    	            New User
        //                        </Link>
	    //        	    	</li>
	    //        	    	<li>
	    //        	    	    <Link to="/all_users" className="nav-link" >
	    //        	    	        <i className="fa fa-address-book cus-margin-rt-5"></i>
	    //        	    	            Registered Users
	    //        	    	    </Link>
	    //        	    	</li>
	    //        	    </ul>
	    //        	</div>
	    //        </li>
	    //     </ul>
        // )

        let userHasAccessToUserCon = true;
        if(this.state.userManagementAccess.length && this.state.userRole){
            if(!this.state.userManagementAccess.includes(this.state.userRole)){
                userHasAccessToUserCon = false;
            }
        }

        return(
              <div data-test = 'sidebarComponent' className="sidenav" >
                  <div className="cus-side-bar-div">
                      <a className="nav-link cus-side-bar-a" onClick = {this.props.handleClick}>
                        <i className="fa fa-times"></i>
                      </a>
                  </div>
                  <div className="cus-side-bar-link-div" style={{ marginBottom: '30%'}}>
                      {/* <Link to="/view_scenario" className="nav-link">
                         View Scenario
                      </Link>
                      <Link to="/addScenario" className="nav-link" >
                        Add Scenarios in Scenario Group
                      </Link>
                      <Link to="/scenario_group" className="nav-link" >
                        Scenario Group View
                      </Link>
                      <Link to="/addTestPoint" className="nav-link" >
                        Add Test Point
                      </Link>
                      <Link to="/upload_file" className="nav-link" >
                        Scheduler
                      </Link>
                      <Link to="/testRunStatus" className="nav-link" >
                        Testrun Status
                      </Link>
                      <Link to="/welcomeautomatekpi/landingkpidashboard" className="nav-link" >
                        KPI Dashboard
                      </Link> */}
                      <Link to="/register" className="nav-link" >
                                  <i className="fa fa-user-plus cus-margin-rt-5"></i>
	           	    	            New User
                      </Link>
                      <Link to="/all_users" className="nav-link" >
	           	    	        <i className="fa fa-address-book cus-margin-rt-5"></i>
	           	    	            Registered Users
	           	    	</Link>
                      {/* {
                        userHasAccessToUserCon ? userManagementControls : null
                      } */}
                  </div>
              </div>
        )
    }
}

//Sidebar.propTypes={
//    handleClick:PropTypes.string
//}
//Sidebar.defaultProps= {
//    handleClick:[]
//}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default Sidebar
